import { Box, Typography } from "@mui/material";
import React from "react";

interface NoDataProps {
	message?: string;
}

const NoData: React.FC<NoDataProps> = ({ message = "No data available." }) => (
	<Box sx={{ textAlign: "center", marginTop: 2 }}>
		<Typography variant="body1">{message}</Typography>
	</Box>
);

export default NoData;
